import store from "modules/store";
import {get} from "lodash";

const trkGuid = "da35e59c-996f-4890-81dc-c844359be64a";

export enum EventGUID {
	HOMEPAGE_LOAD = "a8b27bb1-ec5f-42a3-ab9b-1e5577d2c336",
	ACCOUNT_LOAD = "2ef76c93-5204-40a4-a81e-898ce800c1d7",
	HELP_PAGE_LOAD = "2f0c8a26-66d9-4ef2-a98b-ab107a25a56c",
	REGISTRATION_COMPLETE = "d3f3dd4d-1244-4fee-b788-2902806b5164",
	ACCOUNT_LOGIN = "241fbe6d-25b0-425e-ad25-199c4dca375b",
	GAMEPLAY_START = "b2ec464a-33ae-48e3-a05d-1dcc59f5a12a",
	GAMEPLAY_COMPLETE = "e266e081-a931-43c3-8427-b7f2b5a3e1c0",
	LEAGUES_PAGE_LOAD = "b36c4141-b90a-4f88-8e74-13cf6fd01d56",
	CREATE_LEAGUES = "4480780b-224c-4673-aa4f-cb34bbdaef72",
	CREATE_LEAGUES_COMPLETE = "e016ef27-88ec-4dd2-b4a1-87b0392407ad",
	JOIN_LEAGUES_PAGE_LOAD = "18b5a417-833b-4a57-8a71-76cb3a55c601",
	JOIN_LEAGUES_COMPLETE = "423c41a2-e7c4-417b-b816-6e4dab02aa85",
	LEAGUE_SELECT_LEAGUES = "f8b244b1-d175-44b5-a6f1-6e22cd3f0445",
	// LEAGUE_EMAIL_SHARE = '',
	CREATE_LEAGUES_SHARE_SOCIAL = "20db5f18-75f7-4ad8-a15e-4fdb22abdd90",
	CREATE_LEAGUES_SHARE_COPY = "6617d09f-eeb2-4a09-bb78-118192957749",
	JOIN_LEAGUES_JOIN = "3b86af5c-cf81-4751-ba1e-d9dd16a5c6cf",
	SPONSOR_CLICK = "335f5d33-7777-4652-a9f7-4073f2429fa8",
	HOMEPAGE_SCHEDULE = "a63a2663-0e1c-411e-a75c-a161ddde58fc",
	TUTORIAL_SKIP = "9e239f5c-c7f7-42cb-877e-11c4bedd5350",
	TUTORIAL_NEXT = "de7377a3-e224-4a4d-80e0-8d1586faec8e",
	TUTORIAL_CLOSE = "3243a2bc-f627-41ae-9606-04274741077a",
	TUTORIAL_COMPLETE = "6ef1337b-013a-48ea-acd6-46e02c0049a5",
	GAMEPLAY_AUTOFILL = "2369e06a-5eae-43f3-8ef4-918a3b16cfbc",
	GAMEPLAY_SHARE = "7f5d9d28-2cfe-43e8-afbc-7b7b1acba404",
	NAVIGATION_PRIZES = "a05a6b86-c31d-4382-8475-396e637b0b9d",
	NAVIGATION_HOMEPAGE = "3003904c-0fe0-40dc-b492-eb7a7faef7de",
	NAVIGATION_LEAGUES = "db1a16bb-9606-449c-98e1-75efa37f9a11",
	NAVIGATION_HELP = "1f96e079-cf8f-44e9-9bac-8319c0a9899d",
	NAVIGATION_TUTORIAL = "283849fe-aed0-4906-9b43-c865b1b40157",
	NAVIGATION_LOGIN = "368dc8c1-0ced-4e50-a7f5-71952af7f933",
}

export const createFanHubEvent = (evtGuid: EventGUID) => {
	try {
		const index = Object.values(EventGUID).indexOf(evtGuid);
		const trkGuidInfo = Object.keys(EventGUID)[index];
		console.log(trkGuidInfo);
		const allStore = store.getState();

		const clientUserId = String(get(allStore, "user.id", null));
		const url = null;
		const d1 = "predictor";
		const d2 = null;
		const d3 = null;
		const cnvValue = null;
		const cnvCurrency = null;
		const orderId = null;

		window.FanHub?.createEvent(
			evtGuid,
			trkGuid,
			url,
			d1,
			d2,
			d3,
			cnvValue,
			clientUserId,
			cnvCurrency,
			orderId
		);
	} catch (e) {
		console.error(e);
	}
};

export const createFanHubEventScriptTag = () => {
	const elementName = "script";
	const SCRIPT_ID = "fanhub-tagging";
	document.getElementById(SCRIPT_ID)?.remove();

	const src = `https://tag.fanhub.geniussports.com/js/evt.js`;
	const url = new URL(src);
	const script = document.createElement(elementName);
	const allStore = store.getState();

	const clientUserId = String(get(allStore, "user.currentUser.id", null));

	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	script.setAttribute("data-trkGuid", trkGuid);
	if (clientUserId) {
		script.setAttribute("data-clientUserId", clientUserId);
	}

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};
